import { render, staticRenderFns } from "./GroupPostCreate.vue?vue&type=template&id=48a80101&scoped=true&"
import script from "./GroupPostCreate.vue?vue&type=script&lang=js&"
export * from "./GroupPostCreate.vue?vue&type=script&lang=js&"
import style0 from "./GroupPostCreate.vue?vue&type=style&index=0&id=48a80101&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a80101",
  null
  
)

export default component.exports